import { render, staticRenderFns } from "./template_type.vue?vue&type=template&id=1287d07f&scoped=true&"
import script from "./template_type.vue?vue&type=script&lang=js&"
export * from "./template_type.vue?vue&type=script&lang=js&"
import style0 from "./template_type.vue?vue&type=style&index=0&id=1287d07f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1287d07f",
  null
  
)

export default component.exports